<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span v-if="$route.meta.rtlActive">
          {{ rtlTitle }}
          <b class="caret"></b>
        </span>
        <span v-else>
          {{ title }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <!-- <li>
                <a v-if="$route.meta.rtlActive" href="#vue">
                  <span class="sidebar-mini">مع</span>
                  <span class="sidebar-normal">ملف</span>
                </a>
                <a v-else href="#vue">
                  <span class="sidebar-mini">MP</span>
                  <span class="sidebar-normal">My Profile</span>
                </a>
              </li>
              <li>
                <a v-if="$route.meta.rtlActive" href="#vue">
                  <span class="sidebar-mini">هوع</span>
                  <span class="sidebar-normal">تعديل الملف الشخصي</span>
                </a>
                <a v-else href="#vue">
                  <span class="sidebar-mini">EP</span>
                  <span class="sidebar-normal">Edit Profile</span>
                </a>
              </li> -->
              <li>
                <a v-if="$route.meta.rtlActive" href="#vue">
                  <span class="sidebar-mini">و</span>
                  <span class="sidebar-normal">إعدادات</span>
                </a>
                <a v-else href="#vue" @click="logOut">
                  <span class="sidebar-mini">O</span>
                  <span class="sidebar-normal">Odjavi se</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import api from '@/api/api.js';
import services from '@/api/services';

export default {
  components: {
    CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: 'Tania Andrew',
    },
    rtlTitle: {
      type: String,
      default: 'تانيا أندرو',
    },
    avatar: {
      type: String,
      default: './img/faces/avatar_5.jpg',
    },
  },
  data() {
    return {
      isClosed: true,
    };
  },
  methods: {
    clicked (e) {
      e.preventDefault();
    },
    toggleMenu () {
      this.isClosed = !this.isClosed;
    },
    logOut() {
      api.post(services.users.logout);
      this.$router.push({ path: 'login' });
    },
  },
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
